<template>
  <section>
    <PartnersHeader />
    <PartnersIntro />
    <PartnersIndex
      v-for="(section, index) in sections"
      :key="section.title"
      :class="{ '-alt-top': index > 0 }"
      :section="section"
    />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Partners',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.partners || {}
    }
  },
  computed: {
    sections() {
      return this.$wp.pages.partners.sections || []
    }
  },
  mounted() {
    console.log('partners', this.$wp.pages.partners)
  }
}
</script>
